import React, { useState,useRef } from 'react'
import emailjs from '@emailjs/browser';
import "./contact.scss";
import shake from "../../assets/shake.svg"
import { Spa } from '@mui/icons-material';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Contact = () => {

  

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_rodecq2', 'template_d5e11wf', form.current,
        'qR7eSQagJehOReGdM',
      )
      .then(
        () => {
          console.log('SUCCESS!');
          toast.success('😃 Thanks, I will replay back ASAP', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: "bounce",  // Corrected here to be a string "bounce"
            key:new Date().getTime(),
          });

          form.current.reset();
          
        },
        (error) => {
          console.log('FAILED...', error.text);
        },
      );
  };
  return (
    <div className="contact" id="contact">
      <div className="left">
        
        <img src={shake} alt="" />
      </div>
      <div className="right">
        <h2>Contact</h2>
        <form ref={form} onSubmit={sendEmail}>
          <label>Name</label>
          <input type="text" name="user_name" />
          <label>Email</label>
          <input type="email" name="user_email" />
          <label>Message</label>
          <textarea name="message" />
          <input type="submit" value="Send" />
          
      </form>
      <ToastContainer
  position="top-right"
  autoClose={5000}
  hideProgressBar={false}
  newestOnTop={false}
  closeOnClick
  rtl={false}
  pauseOnFocusLoss
  draggable
  pauseOnHover
  theme="light"
  transition="bounce"
  
/>
      </div>
    </div>
  )
}

export default Contact